import { Component, ViewEncapsulation } from '@angular/core';
import { locale as navigationEnglish } from 'assets/i18n/en';
import { locale as navigationVietNam } from 'assets/i18n/vi';
import { I18nLoaderService } from './core/i18n-loader/i18n-loader.service';
// import { ImagePreloadService } from './core/services/image-preload.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
    theme = '';
    /**
     * Constructor
     */
    constructor(
        // private _imagePreloadService: ImagePreloadService,
        private _i18nLoaderService: I18nLoaderService
    ) {
        // this._imagePreloadService.preloadImage();
        this._i18nLoaderService.loadTranslations(
            navigationEnglish,
            navigationVietNam
        );
        this._i18nLoaderService.useLanguage('vi');
        console.log('App Component loaded !!!');
    }
}
